import { useEffect, useState } from 'react';
import { TrackingData } from '../common/AnalyticsContext/TrackingData';
import { useAnalytics } from '../common/AnalyticsContext/useAnalytics';
import { useBrowser } from '../common/services/BrowserService';

export const DarkModeDetector = () => {
  const { window } = useBrowser();
  const [analytics, setAnalytics] = useState<TrackingData>();
  useAnalytics(analytics);

  useEffect(() => {
    if (!window) return;

    setAnalytics({
      userData: {
        prefersColorScheme: getPreferredColourScheme(window),
      },
    });
  }, [window]);

  return null;
};

const getPreferredColourScheme = (window: Window) => {
  for (const scheme of SCHEMES) {
    if (prefersScheme(window, scheme)) return scheme;
  }

  return 'unknown';
};

const SCHEMES = ['dark', 'light', 'no-preference'] as const;

const prefersScheme = (window: Window, scheme: string) =>
  window.matchMedia?.(`(prefers-color-scheme: ${scheme})`).matches;
